import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-folder-doesnot-exist',
  templateUrl: './folder-doesnot-exist.component.html',
  styleUrls: ['./folder-doesnot-exist.component.scss']
})
export class FolderDoesnotExistComponent implements OnInit {

  @Output() back = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  public handleGoToFiles(): void {
    this.back.emit()
  }

}
